export default __webpack_public_path__ + "static/media/Dr.Bindhiya.13897a69.jpg";